import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';

import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Input from 'b2b-ui-components-lib/lib/components/input';
import { MULTI_SITE_MODULE_ID, AUTH_TOKEN, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';
import { getFromSessionStorage } from 'common/utils/app.utils';
import { emailValidaotr, mobileValidator } from 'common/utils/validator';

import './OrderContactDetails.scss';

const OrderContactDetails = (props: any) => {
  const { contactList, updateOrderContactDetails, selectedContact, setSelectedContact, isOrderConfirmation } = props;
  const handleContactChange = (event: any) => {
    let selectedContact = event;
    let phoneNumberEmpty = selectedContact?.phoneNumber ? false : true;
    let emailEmpty = selectedContact?.email ? false : true;
    setSelectedContact({
      ...selectedContact,
      phoneNumberEmpty: phoneNumberEmpty,
      emailEmpty: emailEmpty
    });
    let orderReqObj = {
      name: event['firstName'],
      role: event['designation'],
      emailId: event['email'],
      contactNumber: event['phoneNumber']
    };
    if (orderReqObj['emailId'] && orderReqObj['contactNumber']) {
      updateOrder(orderReqObj);
    }
  };

  const updateOrder = (orderReq: any) => {
    const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
    updateOrderContactDetails(orderReq, orderAuthToken);
  };

  const [errors, setErrors] = useState<any>({ email: [], phoneNumber: [] });

  const handleContactFormInputChange = (key: string, value: string) => {
    validateAndUpdateErrors(key, value);
    if (key === 'email') {
      setFormTouched(true);
      setSelectedContact({
        ...selectedContact,
        email: value
      });
    }
    if (key === 'phoneNumber') {
      setFormTouched(true);
      setSelectedContact({
        ...selectedContact,
        phoneNumber: value
      });
    }
  };

  const [accordionMeta, setAccordionMeta] = useState({
    isExpanded: true
  });
  const [formTouched, setFormTouched] = useState(false);

  const validateAndUpdateErrors = (key: any, value: any) => {
    let errorList = [];
    if (key === 'email') {
      errorList = emailValidaotr(value);
      setErrors({
        ...errors,
        email: errorList
      });
    }

    if (key === 'phoneNumber') {
      errorList = mobileValidator(value);
      setErrors({
        ...errors,
        phoneNumber: errorList
      });
    }
  };

  useEffect(() => {
    if (formTouched && errors.email.length === 0 && errors.phoneNumber.length === 0 && selectedContact.email && selectedContact.phoneNumber) {
      let orderReqObj = {
        name: selectedContact['firstName'],
        role: selectedContact?.designation,
        emailId: selectedContact['email'],
        contactNumber: selectedContact['phoneNumber']
      };
      updateOrder(orderReqObj);
    }
  }, [errors, formTouched]);

  return (
    <div className="upgrade-order-details upgrade-accordion">
      <Accordion
        autoScrollOnExpand={false}
        isExpanded={accordionMeta.isExpanded}
        title={'Order Contact Details'}
        onExpandClick={() =>
          setAccordionMeta((accordionMeta) => ({
            ...accordionMeta,
            isExpanded: !accordionMeta.isExpanded
          }))
        }
      >
        <div className="upgrade-body">
          <div className="divider" />

          <div className="row">
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <div className="control_group">
                <Select
                  placeholder=""
                  label="Order Contact Name"
                  value={selectedContact}
                  onChange={handleContactChange}
                  options={contactList}
                  required
                  touched
                  disabled={isOrderConfirmation}
                />
              </div>
            </div>
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              {selectedContact && selectedContact.emailEmpty ? (
                <Input
                  type="email"
                  label="Order Contact Email ID"
                  name="email"
                  value={selectedContact && selectedContact.email}
                  onChange={(value: any) => handleContactFormInputChange('email', value)}
                  required
                  touched
                  errors={errors.email}
                  disabled={isOrderConfirmation}
                />
              ) : (
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Order Contact Email ID</label>
                    <div className="value">{selectedContact && selectedContact.email}</div>
                  </div>
                </div>
              )}
            </div>
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              {selectedContact && selectedContact.phoneNumberEmpty ? (
                <Input
                  label="Order Contact Number"
                  name="phoneNumber"
                  value={selectedContact && selectedContact.phoneNumber}
                  onChange={(value: any) => handleContactFormInputChange('phoneNumber', value)}
                  errors={errors.phoneNumber}
                  required
                  touched
                  disabled={isOrderConfirmation}
                />
              ) : (
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Order Contact Number</label>
                    <div className="value">{selectedContact && selectedContact.phoneNumber}</div>
                  </div>
                </div>
              )}
            </div>
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <div className="control_group">
                <div className="prefield_details">
                  <label className="field_label">Order Contact Role</label>
                  <div className="value">{selectedContact?.designation}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Accordion>
    </div>
  );
};

OrderContactDetails.propTypes = {
  contactList: PropTypes.array.isRequired,
  updateOrderContactDetails: PropTypes.func.isRequired,
  selectedContact: PropTypes.object.isRequired,
  setSelectedContact: PropTypes.func.isRequired,
  isOrderConfirmation: PropTypes.bool.isRequired
};

export default OrderContactDetails;
